import { PayloadAction } from '@reduxjs/toolkit';
import { ISignUpState } from './signup.slices';
import {
  checkEmail,
  ICheckEmailResponse,
  ISignUpByEmailResponse,
  resendSignUpEmail,
  signUpByEmail,
  userSignUp,
  userSocialSignUp
} from './signup.thunks';

export const reducers = {
  [checkEmail?.pending.type]: (state: ISignUpState): void => {
    state.form.loading = true;
    state.form.emailChecked = false;
    state.form.validEmail = false;
  },
  [checkEmail?.fulfilled.type]: (state: ISignUpState, action: PayloadAction<ICheckEmailResponse>): void => {
    state.form.loading = false;
    state.form.emailChecked = true;
    state.form.validEmail = !action.payload.used;
  },
  [checkEmail?.rejected.type]: (state: ISignUpState): void => {
    state.form.loading = false;
    state.form.emailChecked = false;
    state.form.validEmail = false;
  },
  [userSignUp.pending.type]: (state: ISignUpState): void => {
    state.form.loading = true;
  },
  [userSignUp.fulfilled.type]: (state: ISignUpState): void => {
    state.form.loading = false;
  },
  [userSignUp.rejected.type]: (state: ISignUpState): void => {
    state.form.loading = false;
  },
  [userSocialSignUp.pending.type]: (state: ISignUpState): void => {
    state.form.loading = true;
  },
  [userSocialSignUp.fulfilled.type]: (state: ISignUpState): void => {
    state.form.loading = false;
  },
  [userSocialSignUp.rejected.type]: (state: ISignUpState): void => {
    state.form.loading = false;
  },
  [signUpByEmail?.pending.type]: (state: ISignUpState): void => {
    state.signUpByEmail.loading = true;
    state.signUpByEmail.email = undefined;
    state.signUpByEmail.showReCaptchaV2 = false;
  },
  [signUpByEmail?.fulfilled.type]: (state: ISignUpState, action: PayloadAction<ISignUpByEmailResponse>): void => {
    state.signUpByEmail.loading = false;
    state.signUpByEmail.email = action.payload.email;
    state.signUpByEmail.showReCaptchaV2 = false;
  },
  [signUpByEmail?.rejected.type]: (state: ISignUpState, action: PayloadAction<ISignUpByEmailResponse>): void => {
    state.signUpByEmail.loading = false;
    state.signUpByEmail.email = undefined;
    state.signUpByEmail.showReCaptchaV2 = true;
  },
  [resendSignUpEmail?.pending.type]: (state: ISignUpState): void => {
    state.resendByEmail.showReCaptchaV2 = false;
  },
  [resendSignUpEmail?.fulfilled.type]: (state: ISignUpState, action: PayloadAction<ISignUpByEmailResponse>): void => {
    state.resendByEmail.showReCaptchaV2 = false;
  },
  [resendSignUpEmail?.rejected.type]: (state: ISignUpState, action: PayloadAction<ISignUpByEmailResponse>): void => {
    state.resendByEmail.showReCaptchaV2 = true;
  }
};
